<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2024-03-01 17:26:05
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-03-04 14:38:24
 * @FilePath: /chaoyongtuan/src/components/business/tagDialog/addTag..vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<el-dialog
		:title="title"
		:visible.sync="visible"
		:append-to-body="appendToBody"
		:width="width"
		:before-close="handleClose"
		:show-close="showClose"
		:close-on-click-modal="closeOnClickModal"
	>
		<div class="pt-10 pl-8 pr-8">
			<el-input type="text" placeholder="请输入标签名称（10字以内）" v-model="tagName" maxlength="10" show-word-limit></el-input>
			<!-- 弹窗内容部分 -->
		</div>
		<span slot="footer">
			<el-button @click="handleClose">取消</el-button>
			<el-button type="primary" @click="confirm" :loading="loading">确认</el-button>
		</span>
	</el-dialog>
</template>
<script>
import { debounce } from 'lodash';
import { saveOrUpdateTag } from '@/api/tagManagement';

export default {
	props: {},
	data() {
		return {
			title: '新建标签', // 弹窗标题
			visible: false, // 弹窗显隐
			loading: false, // 按钮loading状态

			tagName: '',
			type: 0, //
		};
	},
	computed: {
		// 弹窗尺寸转换为实际px值
		width() {
			return dataMap.DIALOG_SIZE_WIDTH[this.size];
		},
	},
	created() {
		this.initData();
	},
	mounted() {},

	methods: {
		// 主动显示弹窗
		show(type) {
			this.visible = true;
			this.type = type;
		},
		// 清空数据并关闭弹窗
		handleClose() {
			this.visible = false;
			this.tagName = '';
		},
		// 确认按钮点击事件
		confirm: debounce(async function () {
			// 按钮loading开启
			this.loading = true;
			try {
				const { tagName } = this;
				await saveOrUpdateTag({ tagsList: [{ tagName: tagName, tagType: 1, appType: 1 }] });
				this.$message.success('操作成功');
				// 刷新列表（外部重新获取数据）
				this.$emit('refresh');
				// 完成之后清空数据
				this.handleClose();
			} finally {
				// 按钮loading关闭
				this.loading = false;
			}
		}, 300),
		// 不需要响应式的数据进行初始化设置
		initData() {
			// 弹窗是否添加到body节点下
			this.appendToBody = true;
			// 弹窗尺寸，small:400px，normal:600px，large:800px
			this.size = 'small';
			// 是否展示弹窗右上角关闭图标
			this.showClose = true;
			// 点击蒙版是否关闭
			this.closeOnClickModal = false;
		},
	},
	components: {},
	beforeDestroy() {},
};
</script>
